import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-publish-all-sections-dialog',
    templateUrl: './publish-all-sections-dialog.component.html',
    styleUrls: ['./publish-all-sections-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class PublishAllSectionsDialogComponent implements OnInit {
    @Input()
    publishSections: boolean;

    @Input()
    title: string;

    @Input()
    immediatelyLabel: string;

    @Input()
    dontPublishLabel: string;

    private _formGroup: FormGroup;

    get formGroup(): FormGroup {
        return this._formGroup;
    }

    constructor(private _formBuilder: FormBuilder, public dialogRef: MatDialogRef<PublishAllSectionsDialogComponent>) {}

    ngOnInit() {
        this._formGroup = this._formBuilder.group({
            publishSections: [this.publishSections, Validators.required],
        });
    }

    async save() {
        const formData = this.formGroup.getRawValue();
        this.dialogRef.close(formData);
    }
}
